class SearchView {
  _parentEl = document.querySelector('.search');
  getQuery() {
    const query = this._parentEl.querySelector('.search__field').value;
    this._clearInput();
    return query;
  }
  addHandlerSearch(handler) {
    this._parentEl.addEventListener('submit', function (e) {
      e.preventDefault();
      handler();
    }); //WOrks no matter user clicks submit button or enters.
  }
  _clearInput() {
    this._parentEl.querySelector('.search__field').value = '';
  }
}
export default new SearchView();
